import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { UserAcdExtensionInfoRemoteDto } from '../../../../generated/signalR/user-acd-extension-info-remote-dto';
import { AcdExtensionsService } from '../../../../generated/swagger';
import { SessionRelevantDataChanged } from '../../session/session.actions';
import { SamwinDeviceAddressChangedByServer } from '../samwin.actions';
import {
   AcdExtensionSearchChanged,
   ActiveAcdExtensionChanged,
   AvailableAcdExtensionsUpdated,
   SelectAcdExtension,
   SwitchAlternativeDevice,
} from './samwin-acd-extension.actions';

export interface SamwinAcdExtensionStateModel {
   assignedAcdExtension: number;
   availableAcdExtensions: UserAcdExtensionInfoRemoteDto[];
   acdExtensionSearchValue: string;
   currentDeviceAddress: string;
}

@State<SamwinAcdExtensionStateModel>({
   name: 'samwinAcdExtension',
   defaults: {
      assignedAcdExtension: null,
      availableAcdExtensions: [],
      acdExtensionSearchValue: '',
      currentDeviceAddress: '',
   },
})
@Injectable()
export class SamwinAcdExtensionState {
   constructor(private acdExtensionsService: AcdExtensionsService) {}

   @Selector([SamwinAcdExtensionState])
   public static getAssignedAcdExtension(state: SamwinAcdExtensionStateModel): number {
      return state.assignedAcdExtension;
   }

   @Action(ActiveAcdExtensionChanged)
   public add(ctx: StateContext<SamwinAcdExtensionStateModel>, action: ActiveAcdExtensionChanged) {
      ctx.patchState({
         assignedAcdExtension: action.selectedAcdExtension,
      });
      ctx.dispatch(new SessionRelevantDataChanged());
   }

   @Action(SelectAcdExtension)
   public selectAcdExtension(ctx: StateContext<SamwinAcdExtensionStateModel>, action: SelectAcdExtension) {
      if (!action.selectedAcdExtension.isAvailable) {
         return;
      }
      return this.acdExtensionsService.selectAcdExtension({ selectedAcdExtension: action.selectedAcdExtension.opextId });
   }

   @Action(AcdExtensionSearchChanged)
   public acdExtensionSearchChanged(ctx: StateContext<SamwinAcdExtensionStateModel>, action: AcdExtensionSearchChanged) {
      ctx.patchState({
         acdExtensionSearchValue: action.newSearchValue,
      });
   }

   @Action(AvailableAcdExtensionsUpdated)
   public availableAcdExtensionsUpdated(ctx: StateContext<SamwinAcdExtensionStateModel>, action: AvailableAcdExtensionsUpdated) {
      ctx.patchState({
         availableAcdExtensions: action.data,
      });
   }

   @Action(SwitchAlternativeDevice)
   public requestUserStatusChange(ctx: StateContext<SamwinAcdExtensionStateModel>, action: SwitchAlternativeDevice) {
      return this.acdExtensionsService.switchAlternativeDevice({
         deviceAddress: action.deviceAddress,
      });
   }

   @Action(SamwinDeviceAddressChangedByServer)
   public samwinDeviceAddressChangedByServer(ctx: StateContext<SamwinAcdExtensionStateModel>, action: SamwinDeviceAddressChangedByServer) {
      ctx.patchState({
         currentDeviceAddress: action.deviceAddress,
      });
   }
}
